import { Entities, EntitiesAllProps, EntitiesTrueName } from 'constants/Entities';
import Context from 'managers/Context';

export const getPermissionsFromState = (state) => state?.config?.permission || {};

// Some entities are permission-gated in menu/routes but don't define generalPermission.
const ENTITY_PERMISSION_FALLBACKS = {
    billboard: 'billboard',
    kpis: 'kpisPremium',
    campaigns: 'verCampaignsAdmin',
};

export const resolveEntityConfig = (entity) => {
    if (!entity) return null;
    if (typeof entity === 'object') return entity;
    if (typeof entity !== 'string') return null;

    return (
        Entities[entity] ||
        EntitiesTrueName[entity] ||
        EntitiesAllProps.find((current) => current.values.includes(entity))?.entity ||
        null
    );
};

export const canViewEntityWithPermissions = (permissions, entity) => {
    const entityConfig = resolveEntityConfig(entity);
    const permissionKey =
        entityConfig?.generalPermission || ENTITY_PERMISSION_FALLBACKS[entityConfig?.entity];

    // If the entity has no resolvable permission key, treat it as not permission-gated.
    if (!permissionKey) return true;
    return Boolean(permissions?.[permissionKey]);
};

export const canViewEntityFromState = (state, entity) => {
    const permissions = getPermissionsFromState(state);
    return canViewEntityWithPermissions(permissions, entity);
};

export const canViewEntity = (entity) => {
    const state = Context?.store?.getState?.();
    return canViewEntityFromState(state, entity);
};

export const canCreateEntityWithPermissions = (permissions, entity) => {
    const entityConfig = resolveEntityConfig(entity);
    if (!entityConfig) return false;

    const canCreate = Boolean(permissions?.crud_permission?.[entityConfig.permission]?.create);

    return canViewEntityWithPermissions(permissions, entity) && canCreate;
};
